import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-trip-address-row',
  templateUrl: './trip-address-row.component.html',
  styleUrls: ['./trip-address-row.component.scss']
})
export class TripAddressRowComponent implements OnInit {

  @Input()
  isPrimary = false;

  constructor() {
  }

  ngOnInit() {
  }

}
